import { _ } from "../../../core/polyglot/polyglot.js";
import { formatAsShortDate } from "../../../core/helpers/date-formatting-util.js";
import { formatCurrency } from "../../../core/helpers/currency-formatting-util.js";
import companyChartLegendItemWidget from "./companyChartLegendItemWidget.js";
import percentage from "../../../core/percentage.js";
import popoverWidget from "../../../core/widgets/popoverWidget/popoverWidget.js";

/**
 * Company legend item for the owners part.
 * The different items in the company chart legend have different colors and pop overs. So that is why we need this.
 */
function companyChartOwnersPartLegendItemWidget(spec, my) {
	spec ||= {};
	my ||= {};

	spec = Object.assign(spec, {
		title: _("Owner's part"),
		legendItemClass: "legend-item-owners-part",
		seriesId: "equity",
		valueRenderer: formatCurrency,
	});

	const that = companyChartLegendItemWidget(spec, my);

	my.createPopover = function (companyBalance) {
		const dateString = formatAsShortDate(companyBalance.date);

		return popoverWidget({
			header: function (html) {
				html.span(dateString, ", ", _("Owner's part"));
			},
			content: function (html) {
				html.label(
					{ class: "key-val-pair" },
					_("Equity"),
					" ",
					html.span(formatCurrency(-companyBalance.equity)),
				);

				const preliminaryResultValue =
					-companyBalance.preliminaryResult;
				if (preliminaryResultValue) {
					html.label(
						{ class: "key-val-pair" },
						_("Preliminary result"),
						" ",
						html.span(formatCurrency(preliminaryResultValue)),
					);
				}
				const previousPreliminaryResultValue =
					-companyBalance.previousPreliminaryResult;
				if (previousPreliminaryResultValue) {
					html.label(
						{ class: "key-val-pair" },
						_("Previous year's preliminary result"),
						" ",
						html.span(
							formatCurrency(previousPreliminaryResultValue),
						),
					);
				}
				const untaxedReservesValue =
					-(1.0 - companyBalance.taxRate) *
					companyBalance.untaxedReserves;
				if (untaxedReservesValue) {
					html.label(
						{ class: "key-val-pair" },
						_("Untaxed reserves ({taxRate})", {
							taxRate: percentage(1.0 - companyBalance.taxRate),
						}),
						" ",
						html.span(formatCurrency(untaxedReservesValue)),
					);
				}
				// if there is only Equity, then there is no need to display sum
				const isSumRequired =
					preliminaryResultValue ||
					previousPreliminaryResultValue ||
					untaxedReservesValue;
				if (isSumRequired) {
					html.label(
						{ class: "key-val-pair" },
						_("Sum"),
						" ",
						html.span(formatCurrency(-companyBalance.ownersPart)),
					);
				}
			},
		});
	};

	return that;
}

export default companyChartOwnersPartLegendItemWidget;
